import { render, staticRenderFns } from "./HistoryAmount.vue?vue&type=template&id=0ea0225a&"
import script from "./HistoryAmount.vue?vue&type=script&lang=js&"
export * from "./HistoryAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoryAmount.vue"
export default component.exports